const routes = [
  {
    path: "atividades",
    component: () => import("@/views/cliente/atividades/Atividades.vue"),
    meta: {
      menu: "dashboard",
      title: "Atividades",   
    },
  },
];

export default routes;
